// TODO(Sina): resolve
/* eslint-disable @tseslint/typedef */
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  WritableSignal
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ImageCropperComponent, ImageCroppedEvent } from 'ngx-image-cropper';
import { provideTranslationScope, TranslationPipeModule } from '@ogs-gmbh/ngx-translate';

export type CropDialogData = {
  imageBase64: string;
  aspectRatio: number;
  format: 'png' | 'jpeg' | 'webp';
};
@Component({
  selector: 'app-image-crop-dialog',
  standalone: true,
  providers: [ provideTranslationScope('shared/image-crop-dialog') ],
  imports: [ CommonModule, MatDialogModule, MatButtonModule, ImageCropperComponent, TranslationPipeModule ],
  templateUrl: './image-crop-dialog.component.html',
  styleUrl: './image-crop-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageCropDialogComponent {
  private readonly dialogRef: MatDialogRef<ImageCropDialogComponent, string | null>
    = inject<MatDialogRef<ImageCropDialogComponent, string | null>>(MatDialogRef);

  readonly data: CropDialogData = inject<CropDialogData>(MAT_DIALOG_DATA);

  readonly cropped: WritableSignal<string | null> = signal<string | null>(null);

  onCropped (croppedEvent: Readonly<ImageCroppedEvent>): void {
    if (croppedEvent.base64)
      this.cropped.set(croppedEvent.base64);
  }

  onCancel (): void {
    this.dialogRef.close(null);
  }

  onConfirm (): void {
    this.dialogRef.close(this.cropped());
  }
}
